var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-popup',{attrs:{"extra-class":"user-deletion-popup no-transparent"}},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"popup-title"},[_vm._v(_vm._s(_vm.$t('auth.for_account_deletion')))]),_c('p',[_vm._v(_vm._s(_vm.$t('auth.enter_sms_code'))+" "+_vm._s(_vm.phone))]),_c('user-deletion-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }